import { Button } from 'components/shadcn/button';
import { IonIcon } from 'components/UI/IonIcon';
import linkDecorator from 'components/UI/linkDecorator';
import { useLanguage } from 'languages/languageContext';
import { cn } from 'utilities/utils';
import Linkify from 'react-linkify';
import { TPrice } from '../types';

export const Card = ({
  product,
  id,
  unit_amount,
  currency,
  isActive,
  recurring,
  createSubscription,
  description,
  isOneTime,
  disabled,
}: TPrice & {
  isActive?: boolean;
  description: string;
  createSubscription: (priceId: string) => Promise<void>;
  isOneTime?: boolean;
  disabled?: boolean;
}) => {
  const { subscription } = useLanguage();

  const duration = recurring?.interval
    ? `${recurring.interval_count > 1 ? recurring.interval_count + ' ' : ''}${subscription[recurring.interval]}`
    : `1 ${subscription.month}`;

  return (
    <div
      className={cn('border-2 rounded-md w-full p-3 hover:scale-[102%] duration-150', isActive && 'border-primary-btn')}
    >
      <div className="flex flex-row justify-between items-center pb-2">
        <h3 className="font-medium">{product.name}</h3>
        <h3 className="font-regular text-sm">
          {(unit_amount / 100).toFixed(2)} {currency?.toUpperCase()}/{duration}
        </h3>
      </div>
      <Linkify componentDecorator={linkDecorator}>{description}</Linkify>
      {isActive && (
        <Button disabled className="text-sm h-8 my-2 bg-gray-300">
          {subscription.subscriptionActive}
        </Button>
      )}
      {!isActive && !disabled && (
        <Button className="text-sm h-8 my-2" onClick={() => createSubscription(id)}>
          Get {product.name} version
        </Button>
      )}
      {disabled && isOneTime && (
        <Button className="text-sm h-8 my-2 bg-slate-500 opacity-0" onClick={() => {}} disabled={true}>
          (bereits benutzt)
        </Button>
      )}
      <ul className="flex flex-col gap-2 text-sm">
        {product.features.map(({ name }) => (
          <li className="gap-2 flex items-center">
            <IonIcon name="checkmark" size={16} />
            {name}
          </li>
        ))}
      </ul>
    </div>
  );
};
